import React from "react";
// import Contactame from "../contectame/Contactame";

const FooterComponent = () => {
  return (
    <footer className="bg-neutral-800/30 rounded-t-xl xs:text-sm mt-36">
      <div className="lg:px-28 px-6 sm:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-0">
        <div className="flex-1 text-center sm:text-left">
          <p className="hidden lg:block text-center">
            Gracias por visitar mi sitio web. ¡Espero que encuentres lo que buscas y nos veamos pronto en nuevos proyectos!
          </p>
          <p className="block lg:hidden text-center">
            Gracias por visitar mi sitio web.
          </p>
        </div>
        <div className="flex justify-center sm:justify-end w-full sm:w-auto">
          {/* <Contactame /> */}
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
